import React from 'react';
import { menuItems } from '../../data/menuItems';
import MenuColumn from './MenuColumn';
import PaymentInfo from './PaymentInfo';
import MenuBanner from './MenuBanner';
import { motion } from 'framer-motion';

export default function Menu() {
  const leftColumnCategories = ['PØLSER & BRØD', 'FRANSKE HOTDOGS', 'HOTDOGS'];
  const rightColumnCategories = ['SANDWICH', 'DIVERSE', 'DRIKKEVARER', 'BENNYS COMMERCIALS'];

  return (
    <div className="py-16 bg-white" id="menu">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.h2 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-3xl font-bold text-center text-red-800 mb-12"
        >
          Menu
        </motion.h2>
        
        <div className="grid md:grid-cols-2 gap-8">
          <MenuColumn 
            categories={leftColumnCategories}
            menuItems={menuItems}
          />
          <div className="space-y-8">
            <MenuColumn 
              categories={rightColumnCategories}
              menuItems={menuItems}
            />
            <PaymentInfo />
            <MenuBanner />
          </div>
        </div>
      </div>
    </div>
  );
}